<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:21:26
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:12:29
-->
<template>
  <div>
    <div class="top">
        <div>
            <el-button style="margin-right:10px" v-if="codeData.indexOf('92') != -1" @click="add(1)" type="primary">新增文件</el-button>
            <el-button style="background: #ecf5ff; color: #176de6;margin-right:10px" v-if="codeData.indexOf('93') != -1" @click="addMulu" type="primary">新增目录</el-button>
            <el-button  style="background: #ecf5ff; color: #176de6;" v-if="codeData.indexOf('94') != -1" @click="toUploadFile" type="primary">上传文件</el-button>
        </div>
        <div class="search">
            <a-input style="width:170px;margin-right:20px" v-model="fileName" placeholder="文件名称" />
            <el-button type="primary" @click="getList(fileName,'',fileName?0:1)">查询</el-button>
        </div>
    </div>
    <div class="content">
        <div class="current-file">
            <div class="back-up" @click="returnParent(directoryPath)" v-if="initialPath!=directoryPath">
               <span  class="icon-arrow-back"></span> 
            </div>
            <span class="icon-folder-open"></span>&nbsp;{{directoryPath}}
        </div>
         <a-spin :spinning="loading">
             <templateTable @editAdmin="add" :templateList="templateList" @editDirectoryPath="editDirectoryPath" @refresh="refresh" :directoryPath="directoryPath"/>
         </a-spin>
    </div>
    <!-- 新增目录 -->
    <div class="add_catalogue">
        <el-dialog title="新增目录" width="600px" :visible.sync="catalogueIsShow"> 
            <div class="lod-tips">
                <span>I</span>
                在 {{directoryPath}}下新增目录
            </div>
            <el-form ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" :model="ruleForm">
                <el-form-item
                    label="目录名称"
                    prop="name"
                >
                <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="bottom">
                <div class="form-bottom">
                    <el-button style="padding:10px 24px" size="small" @click="catalogueIsShow = false">取消</el-button>
                    <el-button v-repeatClick style="padding:10px 24px" size="small" type="primary" @click="saveDirectory">保存</el-button>
                </div>
                    </el-form-item>
                </el-form>
        </el-dialog>
    </div>
    <!-- 新增目录结束    -->
    <!-- 新增文件 -->
    <uploadFile   @close="close" :visible="isShowUpload" :directoryPath="directoryPath"></uploadFile>
  </div>
</template>

<script>
import templateTable from './template_table.vue'
import uploadFile from './upload-file.vue';
import {getTemplateList,addDirectory} from './template_management.js';
export default {
    data(){
        return{
            fileName:'',
            isShowUpload:false,
            catalogueIsShow:false,
            ruleForm:{},
            templateList:[],
            directoryPath:'',
            isShowReturn:true,
            initialPath:'',//初始目录
            loading:false,
            codeData:[],
            rules:{
                name:[
                     { required: true, message: '名称不能为空'}
                ]
            }
        }
    },
    components: {
        templateTable,
        uploadFile
    },
    mounted(){
       this.getList()
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    },
    methods: {
        addMulu(){
            this.catalogueIsShow = true;
            this.ruleForm = JSON.parse(JSON.stringify({}))
            if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields();
            }
            
        },
        add(type,item) {
            let data={}
            console.log(type,'sdas')
            if(type!=1){
                data={
                    path:item?item.allPath:'',
                    fileName:item?item.name:''
                }
            }
            this.$router.push({
                path: "/index/configure/template_management/add_file",
                query: {
                    title: type==1?'新增文件':'修改文件',
                    islast: true,
                    directoryPath:this.directoryPath,
                    ...data
                },
            });
        },
        toUploadFile(){
            this.isShowUpload = true;
        },
        close(){
            this.isShowUpload = false; 
            this.getList('',this.directoryPath,2)
            //this.getList()
        },
        getList(fileName='',path='',type=1){
            const _this = this
            this.loading = true;
            let reqData = {
                "fileName":fileName,
                "path": path,
                "siteId": sessionStorage.getItem('siteId'),
                "type": type
            }
            getTemplateList(reqData).then(res=>{
                if(res.code == 0){
                    _this.directoryPath = res.data.directoryPath
                    _this.templateList = res.data.templateDirectoryAndFileResponse
                    _this.loading = false;
                    if(!_this.initialPath){
                        _this.initialPath=_this.directoryPath
                    }
                    
                }
            })
        },
        saveDirectory(){
            const _this = this
             this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    let path = _this.directoryPath+_this.ruleForm.name
                        addDirectory({path:path}).then(res=>{
                            if(res.code==0){
                                _this.catalogueIsShow = false
                                _this.getList('',_this.directoryPath,2)
                            }
                        })
                }
             })
        },
        editDirectoryPath(data){
            this.getList('',data.path,2)

        },
        //刷新
        refresh(path){
            console.log(path,222)
            this.getList('',path.path,2)
        },
        returnParent(directoryPath){
            // console.log(directoryPath,'dsadsa');
            let path = directoryPath.substring(0,directoryPath.lastIndexOf('/',directoryPath.lastIndexOf('/')-1)+1)
            // console.log(path,'dasdas')
            if(path){
                this.getList('',path,2)
            }
        }
    },
};
</script>

<style lang="less" scoped>
    .top {
        width: 100%;
        padding: 24px;
        border-bottom: solid #E4E7ED 1px;
        display: flex;
        justify-content: space-between;
        .search {
            display: flex;
            width: 254px;
        }
         /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        .add-img {
            margin-top: -2px;
            margin-right: 3px;
        }
        .btn{
            background: #ecf5ff;
            color:#409EFF;
            margin-right: 10px;
            border-color: #afcff7;

        }
    }
    .current-file{
        font-weight: bold;
        line-height: 52px;
        box-sizing: border-box;
        border: solid 1px #dcdfe6;
        padding-right:10px;
        // background: #f7f7f7;
        margin: 36px 26px 0 26px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        .back-up{
            color:#afcff7;cursor: pointer;
            width: 50px;
            box-sizing: border-box;
            border-right: 1px solid #dcdfe6;
            text-align: center;
            padding-top: 6px;
            .icon-arrow-back:before{
                font-size: 20px;
                color: #a9aab1;
            }
        }
        .icon-folder-open{
            margin-left: 10px;
        }
        .icon-folder-open:before{
            font-size: 14px;
        }
    }
    .add_catalogue{
        /deep/.el-dialog__title{
            font-size: 18px;
            font-weight: bold;
        }
        /deep/ .el-dialog__body{
            padding-top: 10px;
        }
       
        .lod-tips{
            background: #f7f7f7;
            font-size: 12px;
            color: #928f8f;
            line-height: 36px;
            padding: 0 10px;
            border-radius: 4px;
        }
        .demo-ruleForm {
            padding: 24px 24px 0 24px;
            width: 100%;
            /deep/.el-form-item{
                margin: 0;
            }
        }
        .bottom{
            text-align: right;
            height: 60px;
            width: 100%;
            .form-bottom{
                margin-top: 24px;
                //margin-right: 24px;
            }
        }
    }
    .el-button--primary {
  background: #176de6;
}

</style>>